import { STOREMODULE_ENDPOINT_MAP, STOREMODULE_ENDPOINTMODULE_MAP } from '@/assets/js/config/server';

import base from '../base';
import CHANGE_REQUESTS from '../base/change-requests';
import MAINENTITY from '../base/entity-main';
import SEARCH from '../base/entity-search-next';
import IS from '../base/is';

function transformTenantProperty (baseDef, tenants) {
  if (!baseDef || !baseDef.properties || !tenants || tenants.length === 0) {
    return baseDef;
  }

  return Object.assign({}, baseDef, {
    properties: baseDef.properties.map(function (p) {
      if (p.name.toLowerCase() !== 'tenant') {
        return p;
      }

      var tenantNames = tenants.map(function (t) { return t.name; });
      var selectValuesMap = tenantNames.reduce(function (acc, name) {
        acc[name] = name;
        return acc;
      }, {});

      var translations = Object.keys(p.translations || {}).reduce(function (acc, lang) {
        acc[lang] = Object.assign({}, p.translations[lang] || {}, {
          selectValues: selectValuesMap
        });
        return acc;
      }, {});

      return Object.assign({}, p, {
        attributeTypeDiscriminator: 'SingleSelectValueAttribute',
        settings: Object.assign({}, p.settings || {}, {
          selectValues: tenantNames
        }),
        translations: translations
      });
    }),
    $properties: baseDef.$properties
  });
}

export default {
  namespaced: true,
  state: base.createState(IS.state, CHANGE_REQUESTS.state, SEARCH.state, MAINENTITY.state, {}),
  getters: base.createGetters(IS.getters, CHANGE_REQUESTS.getters, SEARCH.getters, MAINENTITY.getters, {
    definition: function (state, getters, rootState, rootGetters) {
      var tenants = rootGetters['tenants/getUnwrapped'] || [];
      return transformTenantProperty(state.definition, tenants);
    }
  }),
  mutations: base.createMutations(IS.mutations, CHANGE_REQUESTS.mutations, SEARCH.mutations, MAINENTITY.mutations, {}),
  actions: base.createEntityActions(STOREMODULE_ENDPOINTMODULE_MAP.orders, STOREMODULE_ENDPOINT_MAP.vouchers, IS.actions, CHANGE_REQUESTS.actions, SEARCH.actions, MAINENTITY.actions, {})
};
